module.exports = __webpack_public_path__ + "img/h5img45.11d9bc3c.png";